import Vue from 'vue'

const $pagoda = new Vue()

const getFormGrid = function (coefficient) {
  const filter = (target) => target > 24 ? 24 : target

  const span = filter(12 * coefficient)
  const lgs = filter(8 * coefficient)
  const lgm = filter(6 * coefficient)
  const xl = filter(6 * coefficient)

  return {
    span,
    lgs,
    lgm,
    xl,
    class: 'pagoda-form-grid-cell'
  }
}

$pagoda.form = {
  labelWidth: '114px',
  baseFormWidth: '40%',
  grid: getFormGrid(1),
  gridSpan2: getFormGrid(2),
  gridSpan3: getFormGrid(3),
  gridSpan4: getFormGrid(4)
}

$pagoda.table = {}

$pagoda.dialog = {
  dialogWidth: '43%',
  formWidth: '414px',
  sideDrawerWidth: '497px'
}

Vue.prototype.$pagoda = $pagoda
// 向下兼容
Vue.prototype.$bus = $pagoda

export default $pagoda
